<template lang="pug">
#modal-selecionar-territorios-base-vega-sobrepostos-ar
    el-dialog(
        :visible.sync='show',
        :title='$t("mensagens.territorio.territorioARSobreposto.titulo")',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='85%'
    )
        main
            .mensagem
                p
                    | {{ $t('mensagens.territorio.territorioARSobreposto.foiEncontradaSobreposicao') }}
                    br
                    | {{ $t('mensagens.territorio.territorioARSobreposto.incorporarGeometria') }}

            .mapa
                mapa(
                    :mapLayersConfigs='mapLayersConfigs',
                    :mapConfig='mapConfig',
                    height='100%',
                    idMapa='mapaListCarsAR',
                    ref='mapa'
                )

            .cars-sobrepostos
                .lista
                    el-radio-group(
                        v-model='territorioSelecionado',
                        @change='onSelecionarTerritorio'
                    )
                        .car-sobreposto(
                            v-for='territorio in territoriosBaseVega',
                            :key='territorio.cdTerritorio',
                            @mouseover='highlightTerritorio = territorio',
                            @mouseleave='highlightTerritorio = ``'
                        )
                            .checkbox
                                el-radio(:label='territorio')
                                    | {{ territorio.cdTerritorio }}

        footer.my-3(slot='footer')
            el-button(
                @click='mostrarModalConfirmacaoVoltar = true',
                size='mini'
            )
                | {{ $t('mensagens.comuns.voltar') }}
            el-button(
                v-if='!habilitaOpcaoSalvar',
                disabled,
                type='primary',
                size='mini'
            )
                | {{ $t('mensagens.comuns.salvar') }}
            el-button(v-else, type='primary', size='mini', @click='salvar')
                | {{ $t('mensagens.comuns.salvar') }}

    el-dialog(
        :visible.sync='mostrarModalConfirmacaoVoltar',
        :title='$t("mensagens.territorio.carSobreposto.atencaoVoltarDesfazAlteracoes")',
        :destroy-on-close='true',
        :show-close='false',
        width='30%',
        append-to-body
    )
        footer
            el-button(
                @click='mostrarModalConfirmacaoVoltar = false',
                size='mini'
            )
                | {{ $t('mensagens.comuns.cancelar') }}
            el-button(
                type='primary',
                @click='fecharModalDeSobreposicao',
                size='mini'
            )
                | {{ $t('mensagens.comuns.prosseguir') }}
</template>

<script>
import Mapa from '@/components/MapaLeaflet';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

export default {
    name: 'ModalSelecionarTerritoriosBaseVegaSobrepostosAR',

    components: {
        Mapa
    },

    props: {
        show: {
            type: Boolean,
            required: true,
            default: false
        },

        territoriosBaseVega: {
            type: Array,
            required: false
        },

        geometriaTerritorio: {
            type: Object,
            required: false
        },

        isEdit: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    emits: ['voltar', 'salvar'],

    data() {
        return {
            territorioSelecionado: null,
            mapLayersConfigs: [],
            mapConfig: {
                controls: {
                    zoomControl: true
                }
            },
            highlightTerritorio: '',
            highlightTerritorioAtivo: '',
            mostrarModalConfirmacaoVoltar: false,
            habilitaOpcaoSalvar: false,
            territoriosSelecionados: []
        };
    },

    created() {
        if (this.isEdit) {
            this.highlightTerritorioAtivo = this.territoriosBaseVega[0];
            this.$emit('salvar', this.highlightTerritorioAtivo);
        }
    },

    mounted() {
        this.configureLayersMapa();
    },

    methods: {
        configureLayersMapa() {
            this.mapLayersConfigs = [];
            this.mapLayersConfigs.push({
                style: {
                    stroke: true,
                    color: '#0AFF00',
                    fill: false,
                    weight: 1
                },
                name: this.$t('mensagens.territorio.geometriaTerritorio'),
                geoJson: this.geometriaTerritorio
            });
        },

        fecharModalDeSobreposicao() {
            this.mostrarModalConfirmacaoVoltar = false;
            this.$emit('voltar');
        },

        salvar() {
            this.$emit('salvar', this.highlightTerritorioAtivo);
        },

        onSelecionarTerritorio(territorio) {
            this.mapLayersConfigs = this.mapLayersConfigs.filter(
                ({ name }) =>
                    name !==
                    `highlight_${this.highlightTerritorioAtivo.cdTerritorio}`
            );

            this.highlightTerritorioAtivo = territorio;

            this.mapLayersConfigs.push({
                style: getEstiloGeometria('carHighlight'),
                name: `highlight_${territorio.cdTerritorio}`,
                geoJson: territorio.geometria
            });

            this.habilitaOpcaoSalvar = true;
        }
    }
};
</script>

<style lang="scss" scoped>
#modal-selecionar-territorios-base-vega-sobrepostos-ar {
    main {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-areas:
            'mensagem mensagem'
            'mapa cars-sobrepostos'
            'cars-vinculados cars-vinculados';
    }

    .mensagem {
        grid-area: mensagem;
    }

    .mapa {
        grid-area: mapa;

        height: 400px;
        overflow: hidden;
        border-radius: 4px 0 0 4px;
    }

    .cars-sobrepostos {
        grid-area: cars-sobrepostos;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        height: 400px;
        overflow: auto;

        border-radius: 0 4px 4px 0;
        border: 1px solid var(--gray);
        padding: 16px;

        .lista {
            @include scroll-bar();
            overflow: auto;
            border-bottom: 1px solid grey;
            min-height: 323px;

            .car-sobreposto {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 8px;
                border-radius: 2px;
                margin-bottom: 4px;
            }

            .car-sobreposto:hover {
                background-color: var(--default-background-color);
            }
        }
    }

    .cars-vinculados {
        grid-area: cars-vinculados;

        .lista-cars-vinculados {
            @include scroll-bar();
            display: flex;
            gap: 12px;
            flex-wrap: wrap;
            max-height: 200px;
            overflow: auto;
            border-bottom: 1px solid var(--gray);

            span {
                font-size: 12px;
                width: 350px;
            }
        }
    }

    footer {
        display: flex;
        justify-content: space-between;
    }
}

.el-checkbox {
    margin-bottom: 0 !important;
}
</style>
